export const LoginMFA_Title = 'Multi-Factor Authentication (MFA) Method';

export const LoginMFA_Label = 'Choose how you want to authenticate.';

// DEVICES MFA NAMING
export const EMAIL_OTP = 'otp_email';
export const TOTP_OTP = 'otp_totp';